import { Country, ApiResponse } from '../types';
import {
  getAllCountries,
  getCountryById,
  getPopularCountries,
  searchCountries as searchCountriesLocal,
} from './dataStore';

export const fetchCountries = async (
  continent?: string,
  locale = 'zh'
): Promise<ApiResponse<Country[]>> => {
  try {
    const data = getAllCountries(continent, locale);
    return { data, success: true };
  } catch (error) {
    return {
      data: [],
      success: false,
      message: error instanceof Error ? error.message : '未知错误',
    };
  }
};

export const fetchCountryById = async (
  id: string,
  locale = 'zh'
): Promise<ApiResponse<Country>> => {
  try {
    const data = getCountryById(id, locale);
    if (!data) {
      return {
        data: null as unknown as Country,
        success: false,
        message: '国家不存在',
      };
    }
    return { data, success: true };
  } catch (error) {
    return {
      data: null as unknown as Country,
      success: false,
      message: error instanceof Error ? error.message : '未知错误',
    };
  }
};

export const fetchCountriesByContinent = async (
  continent: string,
  _page = 1,
  _limit = 20,
  locale = 'zh'
): Promise<ApiResponse<Country[]>> => {
  return fetchCountries(continent, locale);
};

export const searchCountries = async (
  query: string,
  locale = 'zh'
): Promise<ApiResponse<Country[]>> => {
  try {
    const data = searchCountriesLocal(query, locale);
    return { data, success: true };
  } catch (error) {
    return {
      data: [],
      success: false,
      message: error instanceof Error ? error.message : '未知错误',
    };
  }
};

export const fetchPopularCountries = async (
  limit = 10,
  locale = 'zh'
): Promise<ApiResponse<Country[]>> => {
  try {
    const data = getPopularCountries(limit, locale);
    return { data, success: true };
  } catch (error) {
    return {
      data: [],
      success: false,
      message: error instanceof Error ? error.message : '未知错误',
    };
  }
};

export const healthCheck = async (): Promise<ApiResponse<{ status: string }>> => ({
  data: { status: 'ok' },
  success: true,
});
